export const passwordNotContainsUsernameError = { passwordContainsUsername: true };

/**
 * Validates that password does not equal or contain the username.
 * Uses balanced strictness (>5 character threshold) to minimize false positives.
 *
 * @param password - The password to validate
 * @param username - The username
 * @returns true if password is valid (does not contain username), false otherwise
 */
export function passwordNotContainsUsername(password: string, username: string): boolean {
  if (!password || !username) {
    return true; // Skip validation if either is empty
  }

  const normalizedPassword = password.toLowerCase();
  const normalizedUsername = username.toLowerCase();

  // Check 1: Password equals username
  if (normalizedPassword === normalizedUsername) {
    return false;
  }

  // Check 2: Password contains username (>5 chars only - BALANCED)
  // This prevents false positives for common short names (e.g., "mike", "john")
  if (normalizedUsername.length > 5 && normalizedPassword.includes(normalizedUsername)) {
    return false;
  }

  return true;
}
